import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../contexts/LanguageContext';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';
import { User, LogOut, Menu } from 'lucide-react';
import SparkleIcon from '../ui/SparkleIcon';
import appConfig from '../../config/appConfig';

const TopNavigation = ({ onHamburgerClick }) => {
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  const handleSignOff = () => {
    // Redirect to sign off URL from config
    window.location.href = appConfig.urls.signOff;
  };

  return (
    <div className="border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="flex h-16 items-center justify-between px-2 sm:px-6">
        {/* Hamburger for mobile */}
        <button
          className="md:hidden mr-2 p-2 rounded focus:outline-none focus:ring-2 focus:ring-primary"
          onClick={onHamburgerClick}
          aria-label="Open sidebar menu"
        >
          <Menu className="h-6 w-6 text-muted-foreground" />
        </button>
        {/* Logo/Brand */}
        <div className="flex items-center space-x-2 rtl:space-x-reverse rtl:space-x-0 rtl:mr-2">
          <div className="h-8 w-8 rounded-lg flex items-center justify-center m-[6px] sm:m-[10px]">
            <SparkleIcon gradient={true} className="w-8 h-8" />
          </div>
          <Link 
            to="/" 
            className="font-semibold text-base sm:text-lg ml-2 sm:ml-8 whitespace-nowrap hover:text-primary transition-colors"
          >
            {t('appName')}
          </Link>
        </div>

        {/* Right side menu */}
        <div className="flex items-center space-x-2 sm:space-x-4 rtl:space-x-reverse rtl:space-x-0 rtl:mr-2">
          {/* Language Switcher - Hidden */}
          {/* <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className={`flex items-center gap-x-1 sm:gap-x-2 px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm ${isRTL ? 'flex-row-reverse' : ''}`}>
                <Globe className="h-4 w-4" />
                <span className="hidden xs:inline">{t('language')}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel>{t('language')}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => handleLanguageChange('en')}>
                <span className={`mr-2 ${currentLanguage === 'en' ? 'text-primary' : ''}`}>
                  🇺🇸
                </span>
                {t('english')}
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleLanguageChange('he')}>
                <span className={`mr-2 ${currentLanguage === 'he' ? 'text-primary' : ''}`}>
                  🇮🇱
                </span>
                {t('hebrew')}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu> */}

          {/* User Menu */}
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="sm" className={`flex items-center gap-x-1 sm:gap-x-2 px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm ${isRTL ? 'flex-row-reverse' : ''}`}>
                <User className="h-4 w-4" />
                <span className="hidden xs:inline">{t('user')}</span>
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={handleSignOff}>
                <LogOut className="mr-2 h-4 w-4" />
                {t('signOff')}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </div>
  );
};

export default TopNavigation; 